module.exports = __webpack_public_path__ + "static/media/ffo_wickelpunkt.6eb194ac.jpg";